import { AppRoutingModule } from './../app-routing.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import {
  MatOptionModule,
  MatCardModule,
  MatInputModule,
  MatStepperModule,
  MatButtonModule,
  MatRadioModule,
} from '@angular/material';
import { CourseSelectorComponent } from './course-selector/course-selector.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    CourseSelectorComponent
  ],
  imports: [
    AppRoutingModule,
    MatSelectModule,
    MatFormFieldModule,
    MatOptionModule,
    MatCardModule,
    MatInputModule,
    MatStepperModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatRadioModule
  ],
  exports: [
    CourseSelectorComponent
  ]
})
export class SetupModule { }
